import { setContext } from "@apollo/client/link/context"
import { getCurrentClientId } from "minimals-template/components/contexts/NognitoContext"
import { instanceId } from "lib/graphql/instance-id"
import { currentSession } from "minimals-template/components/contexts/passport"
import StackTrace from "stacktrace-js"
import { getCopPreviewId } from "routes/sfg20-admin/plugins/codes-of-practice-tab/cop-preview-state"

export const authLink = setContext(async (_, previousContext) => {
    const prevHeaders = previousContext?.headers ?? {}
    try {
        const params = Object.fromEntries(new URLSearchParams(window.location.search).entries())
        let capturedContext
        if (process.env.REACT_APP_DEBUG_STACK) {
            capturedContext = globalThis.compactContext()
            if (capturedContext.stack) {
                capturedContext.stack = await StackTrace.fromError(capturedContext.stack).then(function (stackframes) {
                    return stackframes
                        .slice(3)
                        .map(function (sf) {
                            return sf.toString()
                        })
                        .filter((s) => !s.includes("react-dom"))
                        .join("\n")
                })
            }
        }
        if (params.alttoken) {
            return {
                headers: Object.fromEntries(
                    Object.entries({
                        ...prevHeaders,
                        authorization: `Bearer ${params.alttoken}`,
                        source: params.share,
                        debugcontext: JSON.stringify(capturedContext),
                        clientid: getCurrentClientId(),
                        href: window.location.href,
                        instance: instanceId,
                        "x-cop-preview": getCopPreviewId(),
                    }).filter(([, v]) => !!v)
                ),
            }
        }

        const jwtToken = currentSession()

        return {
            headers: Object.fromEntries(
                Object.entries({
                    ...prevHeaders,
                    authorization: jwtToken !== "undefined" && jwtToken ? `Bearer ${jwtToken}` : undefined,
                    source: params.share,
                    debugcontext: JSON.stringify(capturedContext),
                    clientid: getCurrentClientId(),
                    href: window.location.href,
                    instance: instanceId,
                    "x-cop-preview": getCopPreviewId(),
                }).filter(([, v]) => !!v)
            ),
        }
    } catch (e) {
        console.log(e)
        return { headers: { ...prevHeaders, authorization: "No Token", "x-cop-preview": getCopPreviewId() } }
    }
})
